import log from 'salvo-lite/log'

class BlogAndSearch {
    constructor (components) {
        log.debug('BlogAndSearch', 'Constructing', components)
        this._components = components
    }

    onInit () {
        let articleComponent = this._components.getComponentsById('articleLoadMore')
        if (articleComponent) this.loadMoreArticles(articleComponent)
    }

    loadMoreArticles (articleLoadMore) {
        articleLoadMore._articleContainer = articleLoadMore._elem.parentNode.parentNode
        articleLoadMore._triggerContainer = articleLoadMore._elem.parentNode
        articleLoadMore._articles = document.querySelectorAll('.article-grid-item')
        articleLoadMore._articleGrid = articleLoadMore._articleContainer.querySelector('[data-load-more-items]')
        articleLoadMore._elem.addEventListener('load-more-start', e => {
            log.debug('Blog / Blog Search', 'Load More Started', e)
            articleLoadMore._articleContainer.style.height = articleLoadMore._articleContainer.scrollHeight + 'px'
        })
        articleLoadMore._elem.addEventListener('load-more-complete', e => {
            log.debug('BlogAndSearch', 'Load More Complete', e)
            articleLoadMore._articleContainer.removeChild(articleLoadMore._triggerContainer)
            articleLoadMore.articleItems = e.detail.response.querySelectorAll('.article-grid-item')
            for (let item of articleLoadMore.articleItems) {
                item.classList.add('adding')
                articleLoadMore._articleGrid.appendChild(item)
            }
            if (!e.detail.stop) articleLoadMore._articleContainer.appendChild(articleLoadMore._triggerContainer)
            articleLoadMore._articleContainer.style.height = articleLoadMore._articleContainer.scrollHeight + 'px'
            for (let item of articleLoadMore.articleItems) {
                item.classList.remove('adding')
            }
            articleLoadMore._articles = document.querySelectorAll('.article-grid-item')
            log.debug('BlogAndSearch', 'All Items Added')
        })
    }
}

export default BlogAndSearch



// WEBPACK FOOTER //
// ./src/scripts/pages/BlogAndSearch.js